
type CmsPage = {
  __typename: string;
  data: Group[];
};

type Group = {
  type: string;
  slug: string;
  fields: any[][];
};

export const getPageDataByPath = (
  pages: CmsPage[],
  pathname: string
): Group[] | undefined => {
  const path = pathname.replace(/\/$/, "").split("/").pop();

  const page = pages.find((page) => {
    const navGroup = page.data.find((g) => g.slug === "nav");
    if (!navGroup) return false;

    const navField = navGroup.fields
      .flat()
      .find((f) => f.slug === "nav-path");

    return navField?.text === path;
  });

  return page?.data;
};
